import { EmploymentType } from '../../../Types/Portfolio/EmploymentType';

export const Chowbotics: EmploymentType = {
	company: 'Chowbotics',
	position: 'Technical Lead (Software)',
	objective: 'A company that manufactured and sold food robots.',
	logo: 'https://assets.dear-ux.com/faizhirani/images/logos/Chowbotics.png',
};
